import React from "react";
import { FadeIn } from "components/shared/FadeIn";
import { certifications } from "portfolio";
import CertificationCard from "components/certificationCard/CertificationCard";

function Certifications(): React.ReactElement {
  return (
    <div className="mt-16" id="certs">
      <FadeIn duration={800}>
        <div className="flex items-center gap-3 mb-10">
          <div className="h-px flex-1 bg-border" />
          <div className="flex items-center gap-2">
            <svg
              className="w-4 h-4 text-accent"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
            <h2 className="text-xs font-mono tracking-[0.12em] uppercase text-text-muted">
              Certifications & Awards
            </h2>
          </div>
          <div className="h-px flex-1 bg-border" />
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {certifications.certifications.map((cert, index) => {
          return (
            <CertificationCard key={cert.title + index} certificate={cert} />
          );
        })}
      </div>
    </div>
  );
}

export default Certifications;
